import React from 'react';
import {makeStyles} from "@material-ui/styles";
import {BottomNavigation, BottomNavigationAction} from "@material-ui/core";

// import LinkedIn from "@material-ui/icons/LinkedIn";
// import GitHub from "@material-ui/icons/GitHub";
// import Twitter from "@material-ui/icons/Twitter";
// import Facebook from "@material-ui/icons/Facebook";

import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { FaStackOverflow} from "react-icons/fa";
import { FaMedium } from "react-icons/fa";

const useStyles = makeStyles({
    root: {
        minWdith: 0,
        maxWidth: 250,
        fill: "tan",
        fontSize: "1.8rem",
        color: "#1f1641",
        "&:hover":{
            // color: "#fff",
            // background: "#707070",
            transform: "scale(1.5)"
        },
         transition: "transform 230ms ease-in-out"
    }

})

const Footer = () => {

    const classes = useStyles();

    return (
        <BottomNavigation
            width="auto"
            style={{background: "transparent"}}
            >
            <a 
                href="https://www.linkedin.com/in/pawara73/" 
                target="_blank"
                rel="noreferrer"
            >
                <BottomNavigationAction
                    className={classes.root}
                    style={{padding: "1rem 1rem 0.5rem"}}
                    icon={<FaLinkedin/>}
                    title="Visit Pawara's LinkedIn Profile"
                />
            </a>

            <a
                href="https://github.com/aLLUPS" 
                target="_blank"
                rel="noreferrer"
            >
                <BottomNavigationAction
                    className={classes.root}
                    style={{padding: "1rem 1rem 0.5rem"}}
                    icon={<FaGithub/>}
                    title="Go to Pawara's GitHub account"
                />
            </a>

            <a
                href="https://stackoverflow.com/users/12215054/pawara-siriwardhane" 
                target="_blank"
                rel="noreferrer"
            >
                <BottomNavigationAction
                    className={classes.root}
                    style={{padding: "1rem 1rem 0.5rem"}}
                    icon={<FaStackOverflow/>}
                    title="Visit Pawara's Stackoverflow account"
                />
            </a>

            <a
                href="https://pawara73.medium.com/" 
                target="_blank"
                rel="noreferrer"
            >
                <BottomNavigationAction
                    className={classes.root}
                    style={{padding: "1rem 1rem 0.5rem"}}
                    icon={<FaMedium/>}
                    title="Read Pawara's Medium articles"
                />
            </a>
        </BottomNavigation>
    )
}

export default Footer;
